import { SnackbarProvider, useSnackbar } from "notistack";
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import useAuth from "src/hooks/useAuth";

import { CssBaseline, IconButton } from "@mui/material";
import AppInit from "./components/AppInit";
import ThemeProviderWrapper from "./theme/ThemeProvider";
import { SnackbarUtilsConfigurator } from "./utils/SnackbarUtilsConfigurator";

import { SidebarProvider } from "src/contexts/SidebarContext";
import ScrollTop from "src/hooks/useScrollTop";
import { Outlet } from "react-router-dom";
import CloseRounded from '@mui/icons-material/CloseRounded';

function SnackbarCloseButton({ snackbarKey }) {
  const { closeSnackbar } = useSnackbar();
  return (
    <IconButton onClick={() => closeSnackbar(snackbarKey)} style={{color: "whitesmoke"}}>
      <CloseRounded />
    </IconButton>
  );
}

function App() {
  const auth = useAuth();

  return (
    <SidebarProvider>
      <ScrollTop />
      <ThemeProviderWrapper>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <SnackbarProvider
            maxSnack={6}
            anchorOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
            action={snackbarKey => <SnackbarCloseButton snackbarKey={snackbarKey} />}
          >
            <CssBaseline />
            {auth.isInitialized ? <Outlet /> : <AppInit />}
            <SnackbarUtilsConfigurator />
          </SnackbarProvider>
        </LocalizationProvider>
      </ThemeProviderWrapper>
    </SidebarProvider>
  );
}
export default App;
